<!-- 联系方式 -->
<template>
	<ul class="right_navbar">
		<!-- <li class="right_navbar_btn">
				<el-button circle type="primary" icon="el-icon-phone" title="电话"></el-button>
			</li> -->
		<li class="right_navbar_btn">
			<!-- <a target="_blank" href="http://wpa.qq.com/msgrd?v=1&uin=977207404&Site=http://www.xxxx.com&Menu=yes">
					<img src="../img/qq.jpg" class="qq_logo" title="QQ" alt="QQ" />
				</a> -->
			<!-- <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=979202782&site=qq&menu=yes">
					<img border="0" src="http://wpa.qq.com/pa?p=2:979202782:52" alt="在线咨询" title="在线咨询" />
				</a> -->
			<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=1213076378&site=qq&menu=yes">
				<img border="0" src="../assets/images/common/qq.jpg" class="qq_logo" alt="在线咨询" title="在线咨询" />
			</a>
		</li>
		<li class="right_navbar_btn">
			<el-tooltip class="item" effect="dark" placement="left">
				<figure align="center" slot="content">
					<!--用来定义figure的标题,放在figure的子元素第一个或者最后一个-->
					<img src="../assets/images/common/ewm/lynn.png" class="wechart_qr" alt="公众号">
					<figcaption class="img_title">微信同号 <br> 18519164916</figcaption>
					<!-- <img src="../assets/images/common/ewm/aaron.png" class="wechart_qr" alt="微信">
						<figcaption class="img_title">Aaron</figcaption> -->
				</figure>
				<el-button circle type="success" icon="el-icon-chat-round" title="微信"></el-button>
			</el-tooltip>
		</li>
		<li class="right_navbar_btn">
			<a href="mailto://18519164916@163.com">
				<el-button circle type="info" icon="el-icon-message" title="email"></el-button>
			</a>
		</li>
		<!-- <li class="right_navbar_btn">
				<a href="#header">
					<el-button circle type="danger" icon="el-icon-caret-top" title="到顶部"></el-button>
				</a>
			</li> -->
	</ul>
</template>

<script>
	export default {
		name: 'Contact'
	}
</script>

<style>
	.right_navbar {
		width: 3rem;
		height: 10.5rem;
		position: fixed;
		right: 0.1875rem;
		top: 50%;
		margin-top: -5rem;
		z-index: 100;
		text-align: center;
		list-style: outside none none;
	}

	.right_navbar_btn {
		/* backgcircle-color: #333333; */
		position: relative;
		cursor: pointer;
		height: 3.5rem;
		line-height: 3.5rem;
		color: #FFFFFF;
		transition: all 0.3s ease 0s;
		overflow: hidden;
		word-break: keep-all;
		white-space: nowrap;
	}

	.right_navbar_btn .el-button {
		font-size: 1.2rem;
		border: none;
	}

	/* .right_navbar_btn:hover {
		backgcircle-color: #ff5100;
	} */

	/* 微信二维码 */
	.qq_logo {
		height: 2.75rem;
	}

	.wechart_qr {
		height: 6.25rem;
		width: 6.25rem;
		margin: 0.15625rem auto;
	}

	figure {
		margin: 0 !important;
	}
</style>
